<template>
  <div class="electric">
    <box title="用电告警">
      <div class="electric__context">
        <div class="query">
          <f-filter
            ref="filter"
            :filter-form="formFilter"
            @sendForm="getForm"
            @on-reset="onRefresh"
          ></f-filter>
        </div>
<!--        <div class="btn-item" @click="bigdeal()">-->
<!--          批量处理-->
<!--        </div>-->
        <div class="result">
          <el-tabs v-model="activeName"  @tab-click="handleClick">
            <el-tab-pane v-for="item in status" :label="item.label" :name="item.value + ''"></el-tab-pane>

          </el-tabs>
<!--          <p>查询结果</p>-->
<!--          <span>事件总数</span>-->
<!--          <span style="font-size: 16px; margin-right: 30px; color: #2a62ff">{{-->
<!--            initData.totalCount-->
<!--          }}</span>-->
<!--          <span>已排查</span>-->
<!--          <span style="font-size: 16px; margin-right: 30px; color: #67c23a">{{-->
<!--            initData.checkedCount-->
<!--          }}</span>-->
<!--          <span>已处理</span>-->
<!--          <span style="font-size: 16px; margin-right: 30px; color: #e6a23c">{{-->
<!--            initData.handledCount-->
<!--          }}</span>-->
<!--          <span>处理中</span>-->
<!--          <span style="font-size: 16px; margin-right: 30px; color: #e6a23c">{{-->
<!--              initData.handlingCount-->
<!--            }}</span>-->
<!--          <span>未处理</span>-->
<!--          <span style="font-size: 16px; margin-right: 30px; color: #e6a23c">{{-->
<!--              initData.unHandledCount-->
<!--            }}</span>-->
        </div>
        <div class="list-table">
          <el-table v-loading="loading" :data="reportList" class="tableList">
            <el-table-column
              prop="deptName"
              align="center"
              label="单位名称"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="monitorName"
              align="center"
              label="监测点名称"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="faultName"
              align="center"
              label="事件类型"
            ></el-table-column>
            <el-table-column
              prop="eventName"
              width="160"
              align="center"
              show-overflow-tooltip
              label="事件名称"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="imei"
              align="center"
              label="告警设备imei"
            ></el-table-column>
            <el-table-column
              prop="lastEventValue"
              align="center"
              width="80"
              show-overflow-tooltip
              label="告警值"
            ></el-table-column>
            <el-table-column
              prop="lastEventTime"
              align="center"
              label="	最新告警时间"
            ></el-table-column>
            <el-table-column
              prop="handleStatusName"
              align="center"
              width="120"
              label="事件状态"
            ></el-table-column>
            <el-table-column
              prop="eventCount"
              align="center"
              width="120"
              label="事件总数"
            ></el-table-column>
            <el-table-column
            prop="eventReasonName"
            align="center"
            width="120"
            label="事件标记"
          ></el-table-column>
            <el-table-column align="center" label="操作" min-width="200">
              <template slot-scope="scope">
                <span
                  class="table__list__btn"
                  @click="showEventlist(scope.row)"
                >
                  查看列表
                </span>
                <span

                  v-show="menusList.indexOf('ALARM_EVENT_HANDLE')!='-1'"
                  class="table__list__btn"
                  @click="shownewDialog(scope.row)"
                >
                  处理
                </span>
                <span
                  v-show="menusList.indexOf('ALARM_EVENT_HANDLE')!='-1'"
                  class="table__list__btn"
                  @click="syncSubmittingId === null && syncThirdParty(scope.row)"
                >
                  同步
                </span>
                <span
                  v-if="scope.row.eventState == '已处理'"
                  v-show="menusList.indexOf('ALARM_EVENT_HANDLE')!='-1'"
                  class="table__list__btn"
                  @click="showEditDialog(scope.row)"
                >
                  修改
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="float: right; margin-right: 10px; margin-top: 10px">
          <el-pagination
            @current-change="pageChange"
            background
            :current-page="page"
            :page-size="sizePage"
            layout="total,prev, pager, next, jumper"
            :total="totalSum"
          >
          </el-pagination>
        </div>
      </div>
    </box>

    <el-dialog
      title="用电告警处置"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      class="electricDialog"
    >
      <div class="electricDialog__content">
        <div class="content_top">
          <span> <img src="../img/icon.png" />事件处理</span>
          <!--          <el-checkbox v-model="checked">已处置</el-checkbox>-->
        </div>

        <el-input
          type="textarea"
          autosize
          placeholder="请输入内容"
          v-model="eventHandle"
        >
        </el-input>
        <div class="checkbox">
          <p>针对该事件，如您有以下反馈，欢迎填写：</p>
          <div class="radio">
            <span class="em">报警原因</span>
            <el-checkbox-group v-model="eventReasonCodeList" class="check">
              <el-checkbox
                v-for="city in cities"
                :label="city.value"
                :key="city.value"
                >{{ city.label }}</el-checkbox
              >
              <el-input
                v-model="otherReasonDesc"
                v-if="eventReasonCodeList.indexOf(255) != '-1'"
                style="width: 145px; margin-left: 10px"
              ></el-input>
            </el-checkbox-group>
          </div>
          <div class="radio">
            <span class="em">阈值反馈</span>
            <el-radio-group v-model="thresholdFeedback">
              <el-radio :label="1"
                >合理<span style="color: rgba(0, 0, 0, 0)">合理</span></el-radio
              >
              <el-radio :label="2">不合理</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="btn" @click="confirm">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="批量处置"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="false"
      append-to-body
      class="electricDialog"
    >
      <div class="electricDialog__content">
        <div class="select-con">
          <span>事件类型：</span>
          <el-select
            v-model="dealeventtype"
            size="large"
            placeholder="请选择"

          >
            <el-option
              v-for="i in eventTypelist"
              :key="i.value"
              :label="i.label"
              :value="i.value"
            >
            </el-option>
          </el-select>
          <div style="margin-top: 10px;">
            <span>时间选择：</span>
            <el-date-picker

              v-model="startDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="开始时间"
              size="large"
            ></el-date-picker>
            <span style="padding: 0 4px"> - </span>
            <el-date-picker

              v-model="endDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束时间"
              size="large"
            ></el-date-picker>
          </div>

        </div>
        <div class="content_top">
          <span> 事件处理:</span>
          <!--          <el-checkbox v-model="checked">已处置</el-checkbox>-->
        </div>

        <el-input
          type="textarea"
          autosize
          placeholder="请输入内容"
          v-model="eventHandle"
        >
        </el-input>
        <div class="checkbox">
          <p>针对该事件，如您有以下反馈，欢迎填写：</p>
          <div class="radio">
            <span class="em">报警原因</span>
            <el-checkbox-group v-model="eventReasonCodeList" class="check">
              <el-checkbox
                v-for="city in cities"
                :label="city.value"
                :key="city.value"
              >{{ city.label }}</el-checkbox
              >
              <el-input
                v-model="otherReasonDesc"
                v-if="eventReasonCodeList.indexOf(255) != '-1'"
                style="width: 145px; margin-left: 10px"
              ></el-input>
            </el-checkbox-group>
          </div>
          <div class="radio">
            <span class="em">阈值反馈</span>
            <el-radio-group v-model="thresholdFeedback">
              <el-radio :label="1"
              >合理<span style="color: rgba(0, 0, 0, 0)">合理</span></el-radio
              >
              <el-radio :label="2">不合理</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="btn" @click="confirm2">确 定</el-button>
        <el-button @click="canceldata()">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="事件列表"
      :visible.sync="eventshow"
      :close-on-click-modal="false"
      append-to-body

    >
      <eventData v-if="eventshow" :eventid="eventid" :eventCount="eventCount" :eventname="eventname"/>

    </el-dialog>
    <el-dialog
      title="事件处置"
      :visible.sync="dealshow"
      :close-on-click-modal="false"
      append-to-body
      width="964px"
    >
      <dealeven :eventid="eventid" :dealshow="dealshow" @showdeal="changedeal">

      </dealeven>

    </el-dialog>
  </div>
</template>

<script>
import fFilter from "../../component/warmfilter";
import dealeven from "../../component/dealeven";
import box from "../../component/box";
import eventData from "../../component/evenlist";
import Axios from "../../../utils/Axios";
import Vue from "vue";
import qs from "qs";
export default {
  name: "electroWarn",
  components: { box, fFilter ,eventData,dealeven },
  data() {
    return {
      syncSubmittingId: null,
      loading: false,
      eventshow: false,
      dealshow: false,
      deptList: [],
      menusList: [],
      eventTypelist: [],
      dealeventtype:"",
      activeName: '9',
   status: [
     {
       label: "全部",
       value: "9",
     },
   ],
      formFilter: [
        {
          name: "起止时间",
          endDate: "endDate",
          startDate: "startDate",
          type: "date",
          span: 9,
        },

        {
          name: "事件类型",
          type: "typeSelect",
          field: "eventType",
          span: 5,
        },
        {
          name: "单位",
          type: "tree",
          field: "deptId",
          span: 5,
        },
      ],
      startDate: "",
      endDate: "",
      formdata:{
        endTime: "",
    faultCode: "",
    handleStatus: "",
    startTime: "",
      },
      value: "",
      checked: "",
      options: [
        {
          label: "全部",
          value: "",
        },
        {
          value: 1,
          label: "已处理",
        },
        {
          value: 0,
          label: "未处理",
        },
      ],
      options2: [
        {
          label: "全部",
          value: "",
        },
      ],
      cities: [
        { label: "异常用电", value: 1 },
        { label: "存在隐患", value: 2 },
        { label: "误报干扰", value: 3 },
        { label: "其他", value: 255 },
      ],
      input: "",
      eventName: "",
      eventid: "",
      eventType: "",
      eventState: "",
      eventname: "",
      eventCount: "",
      reportList: [],
      page: 1,
      sizePage: 10,
      totalSum: 0,
      dialogVisible: false,
      dialogVisible2: false,
      eventHandle: "",
      eventId: "",
      eventReasonCodeList: [],
      thresholdFeedback: "",
      otherReasonDesc: "",
      deptId: [],
      initData: {
        totalCount:0,
        checkedCount:0,
        handledCount:0,
        handlingCount:0,
       unHandledCount:0,
      },
    };
  },
  methods: {
    async syncThirdParty(row) {
      try {
        await this.$confirm("确认将该告警同步至第三方平台吗？", "告警同步", { type: "warning" });
      } catch (e) {
        return;
      }
      this.syncSubmittingId = row.id;
      try {
        const res = await Axios.ajax({
          method: "post",
          url: "/event/syncThirdParty",
          data: { id: row.id },
        });
        if (res.resultCode == "0") {
          this.$message.success("告警同步任务已提交");
        } else {
          this.$message.error(res.resultMessage || "提交告警同步任务失败");
        }
      } catch (e) {
        this.$message.error("提交告警同步任务失败");
      } finally {
        this.syncSubmittingId = null;
      }
    },
    handleClick(tab, event) {

      this.queryTableList(this.formdata)
    },
    changedeal(){
      this.dealshow=false
      this.queryTableList();
    },
    shownewDialog(data){
      console.log(data)
      this.dealshow=true
      this.eventid = data.id;
    },
    showEventlist(data){
      this.eventshow=true
      this.eventid=data.id
      this.eventname=data.eventName
      this.eventCount=data.eventCount

    },
    canceldata(){

      this.endDate="";
      this.startDate=""
      this.dealeventtype=""
      this.eventHandle=""
      this.eventReasonCodeList=""
      this.otherReasonDesc=""
      this.thresholdFeedback=""
      this.dialogVisible2 = false;
    },
    confirm2() {
      const param = {
        url: "/event/batchUpdateState",
        method: "post",
        data: {
          endDate:this.endDate,
          startDate:this.startDate,
          faultCode:this.dealeventtype,
          eventHandle: this.eventHandle,
          eventReasonCodeList: this.eventReasonCodeList,
          otherReasonDesc: this.otherReasonDesc || "",
          thresholdFeedback: this.thresholdFeedback,
        },
      };
      Axios.ajax(param).then((res) => {
        if (res.resultCode == 0) {
          this.$message.success("成功！");
          this.canceldata();
          this.queryTableList();
        } else {
          this.$message({
            type: "error",
            message: res.resultMessage,
          });


        }
      });
    },
    bigdeal(){
      this.dialogVisible2=true
    },
    getForm(form, key) {
      if (key) {
        this.page = 1;
        this.queryTableList(form);
        this.queryInit(form);
      } else {
        this.queryTableList(form);
        this.queryInit(form);
      }
    },
    onRefresh(form) {
      this.formdata=form
      this.queryTableList(form);
    },
    queryEventFaults() {
      Axios.ajax({
        url: "/event/getFaults",
        method: "post",
      }).then((res) => {
        if (res.data) {
          res.data.map((item) => {
            this.eventTypelist.push({
              value: item.faultCode,
              label: item.faultName,
            });
          });
          this.eventTypelist.unshift({
            value: "",
            label: "全部",
          });
        }
      });
    },
    queryEventstatus() {
      Axios.ajax({
        url: "/event/getHandleStatus",
        method: "post",
      }).then((res) => {
        if (res.data) {
          res.data.map((item) => {
            this.status.push({
              value: item.status + 2,
              label: item.name,
            });
          });

        }
      });
    },
    confirm() {
      const param = {
        url: "/event/updateState",
        method: "post",
        data: {
          id: this.eventId,
          eventHandle: this.eventHandle,
          eventReasonCodeList: this.eventReasonCodeList,
          otherReasonDesc: this.otherReasonDesc || "",
          thresholdFeedback: this.thresholdFeedback,
        },
      };
      Axios.ajax(param).then((res) => {
        if (res.resultCode == 0) {
          this.$message.success("成功！");
          this.dialogVisible = false;
          this.queryTableList();
        } else {
          this.$message({
            type: "error",
            message: "失败！",
          });
          this.dialogVisible = false;
          this.clearDialog();
        }
      });
    },

    queryTableList(form = {}) {
      this.loading = true;
      this.reportList = [];
      this.queryInit(form);
      const params = {
        url: "/event/page",
        method: "post",
        data: {
          startTime: form.startDate,
          endTime: form.endDate || "",
          pageNum: form.page == 1 ? form.page : this.page,
          showNum: this.sizePage,

          handleStatus: this.activeName==9?'':this.activeName - 2,
          faultCode: form.eventType,
          deptId: form.deptId
            ? form.deptId[form.deptId.length - 1]
            : form.deptId,
        },
      };
      Axios.ajax(params).then((res) => {
        if (res.data) {
          this.loading = false;
          this.reportList = res.data.dataList;
          this.totalSum = res.data.totalNum;
        }
      });
    },
    showEditDialog(row) {
      this.clearDialog();
      this.dialogVisible = true;
      this.eventId = row.eventId;
      const param = {
        url: "/event/getUpdateStateDetail",
        method: "post",
        data: {
          id: row.eventId,
        },
      };
      Axios.ajax(param).then((res) => {
        this.eventHandle = JSON.parse(JSON.stringify(res.data.eventHandleDesc));
        this.eventReasonCodeList = res.data.eventReasonCodeList || [];
        this.otherReasonDesc = res.data.otherReasonDesc || "";
        this.thresholdFeedback = JSON.parse(
          JSON.stringify(res.data.thresholdFeedback)
        );
      });
    },
    showDialog(row) {
      this.clearDialog();
      this.dialogVisible = true;
      this.eventId = row.eventId;
    },
    clearDialog() {
      this.eventHandle = "";
      this.eventReasonCodeList = [];
      this.otherReasonDesc = "";
      this.thresholdFeedback = null;
    },
    queryInit(form = {}) {

      Axios.ajax({
        url: "/event/count",
        method: "post",
        data:{
          startTime: form.startDate || "", //默认为查全部
          endTime: form.endDate,
          // eventName: form.eventName,
          handleStatus: form.eventState,
          faultCode: form.eventType,
          deptId: form.deptId
            ? form.deptId[form.deptId.length - 1]
            : form.deptId,
        },
      }).then((res) => {
        if (res.data) {
          this.initData.totalCount = res.data.totalCount;
          this.initData.checkedCount = res.data.checkedCount;
          this.initData.handledCount = res.data.handledCount;
          this.initData.handlingCount = res.data.handlingCount;
          this.initData.unHandledCount = res.data.unHandledCount;
        }
      });
    },
    // 当前页数
    pageChange(val) {
      this.page = val;
      this.$refs.filter.onSearch();
    },
  },
  created() {},
  mounted() {
    this.menusList=Vue.prototype.menusList
    this.queryEventFaults();
    this.queryEventstatus();
    // this.queryTableList();
    // this.queryInit();
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.electric {
  .electric__context {
    height: 100%;
    padding: 36px;
    overflow: auto;
    .result {
      font-size: 14px;
      color: #252b3c;
      position: relative;
      top: 16px;
      p {
        margin: 12px 0;
      }
      span {
        margin-right: 12px;
      }
    }
    .list-table {
      margin-top: 20px;
      height: 500px;
      overflow: auto;
    }
  }
}
.select-con{
  margin: 10px 0 10px 10px;
}
.btn-item{
  display: inline-block;
  width: 100px;
  height: 40px;
  background: #2A62FF;
  border-radius: 4px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  float: right;
  cursor: pointer;
  margin-top: 10px;
}
.table__list__btn {
  color: #2a62ff;
  font-weight: normal;
}
.table__list__btn:hover {
  cursor: pointer;
}
</style>
<style lang="less">
.eventDialog{
  padding: 0 45px;
  width: 1200px;
  border-radius: 8px;
}
.electricDialog {
  .el-dialog {
    padding: 0 45px;
    width: 759px;
    border-radius: 8px;
    .el-dialog__header {
      text-align: center;
      font-size: 16px;
      color: red;
      font-weight: normal;
      .el-dialog__headerbtn {
        right: 65px;
        font-size: 24px;
      }
    }
    .el-dialog__body {
      .electricDialog__content {
        .content_top {
          display: flex;
          justify-content: space-between;
          margin-bottom: 16px;
          padding-left: 10px;
          span {
            font-size: 14px;
            font-weight: normal;
            color: #252b3c;
            img {
              margin-right: 12px;
            }
          }
          .el-checkbox {
            font-size: 14px;
          }
        }
        .el-textarea {
          .el-textarea__inner {
            min-height: 80px !important;
            height: 80px !important;
          }
        }
        .checkbox {
          p {
            margin: 20px 0;
            font-size: 14px;
            font-family: OPPOSans-M, OPPOSans;
            font-weight: normal;
            color: #252b3c;
            line-height: 24px;
          }
          .radio {
            display: flex;
            align-items: center;
            margin-bottom: 14px;
            .em {
              font-size: 14px;
              font-family: OPPOSans-R, OPPOSans;
              font-weight: normal;
              color: #252b3c;
              line-height: 24px;
              margin-right: 32px;
            }
            .el-radio__label {
              color: #7d879f;
            }
          }
        }
        .el-checkbox__inner {
          border-radius: 50%;
        }
      }
    }

    .el-dialog__footer {
      .dialog-footer {
        .btn {
          background: #2a62ff;
          border: 1px solid #2a62ff;
        }
      }
    }
  }
}

</style>
<style>
#app .el-pagination .el-pager li.active {
  color: #fff;
}
</style>
